import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import logo from "../../../Assets/images/logo.png";
import styles from "../../../layout/Auth/Auth.module.scss";
import {
  GET_HOME,
  GET_PICK_UP_LISTING,
  GET_SERVICES_TYPES,
} from "../../../services/ApiCalls";
import { catchAsync, checkResponse } from "../../../utilities/utilies";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step0 from "./step0";
import Step3 from "./Step3";

const PublicPage = () => {
  const [step, setStep] = useState(0);
  const [selectedService, setSelectedService] = useState();
  const [services, setServices] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [pickUpListing, setPickUpListing] = useState([]);
  const [step0FormData, setStep0FormData] = useState({
    customerName: "",
    customerEmail: "",
    customerMobileNumber: "",
    customerCountryCode: "",
  });

  const [step1FormData, setStep1FormData] = useState({});
  const [step2FormData, setStep2FormData] = useState({});

  // function to load new page when click on get it by delvit.
  // const loadParentPage = () => {
  // 	window.parent.location.href = `${URL.DELVIT_URL}${URL.PRODUCT_GETIT_BY_DELIVIT}`;
  // };

  useEffect(() => {
    getOptionsData({
      setOptions: setServices,
      api: GET_HOME,
      dataPath: "serviceTypes",
    });

    getOptionsData({
      setOptions: setPickUpListing,
      api: GET_PICK_UP_LISTING,
      dataPath: "pickupSizeList",
    });
  }, []);

  return (
    <>
      {/* <div>
        <Row>
          <Col lg="3" className="my-2">
            <div className={`${styles.btnWrpper} btnWrpper`}>
              <Button
                onClick={loadParentPage}
                className="d-flex align-items-center justify-content-center w-100 commonBtn"
                type="button"
              >
                Get it by Delivit
              </Button>
            </div>
          </Col>
        </Row>
		  </div> */}
      <section
        className={`${styles.authLayout} authLayout position-relative py-3 d-flex align-items-center justify-content-center flex-column`}
        style={{ zIndex: "9" }}
      >
        <Container className="">
          <Row className="justify-content-center text-align-center">
            <Col lg="12" className="my-2">
              <div
                className={`${styles.formWrpper} formWrpper `}
                style={{ background: "#FBFBFB", height: "90vh" }}
              >
                <Row className="h-100">

                  <Col lg="12" className="my-2 py-4 h-100">
                    <div className="formInner overflow-auto px-lg-5 px-3 position-relative h-100">

                      <div className="w-100 inner">
                        {step === 0 ? (
                          <>
                            <Step0
                              setStep={setStep}
                              step0FormData={step0FormData}
                              setStep0FormData={setStep0FormData}
                              selectedService={selectedService}
                              setServiceTypes={setServiceTypes}
                              services={services}
                              setSelectedService={setSelectedService}
                              serviceTypes={serviceTypes}
                              pickUpListing={pickUpListing}
                            />


                          </>
                        ) : step === 1 ? (
                          <>
                            <Step1
                              setStep={setStep}
                              step1FormData={step1FormData}
                              setStep1FormData={setStep1FormData}
                              pickUpListing={pickUpListing}
                              serviceTypes={serviceTypes}
                              selectedService={selectedService}
                            />

                          </>
                        ) : step === 2 ? (
                          <Step2
                            setStep={setStep}
                            step1FormData={step1FormData}
                            step2FormData={step2FormData}
                            setStep2FormData={setStep2FormData}
                            // serviceTypes={serviceTypes}
                            selectedService={selectedService}
                          />
                        ) : step === 3 ? (
                          <Step3
                            setStep={setStep}
                            step1FormData={step1FormData}
                            formData={step0FormData}
                            selectedService={selectedService}
                            step0FormData={step0FormData}
                            setStep0FormData={setStep0FormData}
                            step2FormData={step2FormData}
                          />
                        ) : null}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default PublicPage;

const getOptionsData = catchAsync(
  async ({ setOptions, api, dataPath = "normal" }) => {
    const res = await api();
    checkResponse({
      res,
      setData: (data) => {
        if (dataPath === "normal") {
          return setOptions(
            data?.map((item) => ({
              label: item?.name,
              value: item?.name,
            }))
          );
        }

        if (dataPath === "pickupSizeList") {
          return setOptions(data ? data[dataPath] : []);
        }

        if (dataPath === "serviceTypes") {
          return setOptions(
            data?.serviceTypes?.map((item) => {
              if (item?.name === "Towing Service") {
                return {
                  label: item.name,
                  value: "Towing",
                };
              } else {
                return {
                  label: item.name,
                  value: "PickupDrop",
                };
              }
            })
          );
        }

        setOptions(
          data?.[dataPath]?.map((item) => ({
            label: item?.name,
            value: item?.name,
          }))
        );
      },
    });
  }
);
